/**
 * @file 商城store
 */
import Vue from 'vue';
import Vuex from 'vuex';
import server from '@/pages/pano-game/service';
import Const from '@/pages/pano-game/constant/Constant';

Vue.use(Vuex);

const state = {
    welfareData: {},
    activityStatus: 1,
    shareCode: '',
    shareType: 1,
    kouLing: '',
    // 当前金币数
    myCoin: 0,
    // 当前徽章数
    medalNum: 0,
    // 当前现金
    myCash: 0,
    // 每日可抽奖剩余次数
    lotteryRemain: 0,
    // 每日可抽奖总次数
    lotteryCount: 5,
    // 徽章抽奖需要消耗数
    lotteryMedal: 2,
    // 金币抽奖需要消耗数
    lotteryCoin: 100,
    taskInfo: [],
    prizeList: []
};

const mutations = {
    setWelfareData(state, data) {
        state.welfareData = data;
        state.activityStatus = data.activityStatus;
        state.kouLing = data.kling;
        state.shareCode = data.shareCode;
        state.myCoin = Number(data.myCoin) || 0;
        state.medalNum = data.medalNum || 0;
        state.myCash = data.cash || 0;
        state.lotteryRemain = data.lotteryRemain || 0;
        state.lotteryCount = data.lotteryCount || 0;
        state.lotteryMedal = data.lotteryMedal || 2;
        state.shareType = data.shareType;
        state.prizeList = data.prizeList;
        state.taskInfo = [];
        const taskInfoKey = Object.keys(data.taskInfo);
        if (taskInfoKey && taskInfoKey.length) {
            state.taskInfo = taskInfoKey.map(key => data.taskInfo[key]);
        }
    },
    // 设置剩余徽章和金币
    setPrizeInfo(state, data) {
        state.medalNum = data.myMedal || 0;
        state.myCoin = Number(data.myCoin) || 0;
    },
    // 设置抽奖次数
    setLotteryRemain(state, data) {
        state.lotteryRemain = data;
    }
};
const getters = {
};
const actions = {
    // 获取任务抽奖信息
    getTaskLotteryInfo: ({commit, rootState}, params) => {
        const reqParams = {
            ...params,
            type: rootState.isMedal ? Const.gameMode.kingRoad : ''
        };
        return server('getTaskLotteryInfo', reqParams)
            .then(res => {
                if (res && res.errno === 0 && res.data) {
                    commit('setWelfareData', res.data);
                    return res.data;
                }
                throw new Error(res.errstr || 'GetTaskLotteryInfo 数据结构异常');
            })
            .catch(err => {
                throw err;
            });
    },

    // 完成活动任务
    finishTask: ({commit}, param) => {
        return server('finishTask', param).then(res => {
            if (res && res.errno === 0 && res.data) {
                return res.data;
            }
            throw new Error(res.errstr || 'finishtask 数据结构异常');
        });
    },

    // 完成五一大运营任务,现在暂未启用
    finishMainTask: ({rootState}) => {
        let reqParams = {
            activity: 'christmas21',
            type: 'quanjing',
            cuid: rootState.urlParams.cuid
        };
        return server('finishMainTask', reqParams)
            .then(res => {
                if (!res || res.errno !== 0) {
                    throw new Error(res.errstr);
                }
            });
    },

    // 抽奖
    lottery: ({commit, state, rootState}) => {
        const reqParams = {
            type: rootState.isMedal ? Const.gameMode.kingRoad : ''
        };
        return server('lottery', reqParams).then(res => {
            if (res && res.errno === 0 && res.data && res.data.prizeInfo) {
                // 更新剩余徽章数
                commit('setPrizeInfo', res.data.prizeInfo);
                // 更新剩余可抽奖次数
                if (rootState.isMedal && state.lotteryRemain > 0) {
                    commit('setLotteryRemain', state.lotteryRemain - 1);
                }
            }
            else {
                throw new Error(res.errstr || 'lottery 数据结构异常');
            }
            return res.data;
        });
    },

    // 领取金币
    getCoins: ({}, param) => {
        return server('getCoins', param);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};